import { render, staticRenderFns } from "./BaboonRN.vue?vue&type=template&id=21611636&scoped=true"
import script from "./BaboonRN.vue?vue&type=script&lang=js"
export * from "./BaboonRN.vue?vue&type=script&lang=js"
import style0 from "./BaboonRN.vue?vue&type=style&index=0&id=21611636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21611636",
  null
  
)

export default component.exports